import React, {useState, useEffect} from 'react';

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import classnames from "classnames";
import {useDealContext} from "../../contexts/DealContext";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import Tooltip from "@mui/material/Tooltip";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import {CustomSelect} from "../../components/CustomSelect";
import {DeskingModal} from "../PricingListPage/DeskingModal";
import {useModalsStore} from "../../stores/modalsStore";
import {CostCalculator} from "../../components/CostCalculator";
import Switch from "@mui/material/Switch";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import {NumericFormat} from "react-number-format";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export const mileageOptions = [5000, 7500, 10000, 10500, 12000, 15000]

export const termOptions = ['18','24','27','30','33','36','39','42','45','48','60','72']

export const DealPagePayment = ({ isDealPage }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {
        dealState,
        dealColorLight,
        setDealStateWithUpdate,
        updateDealResponse,
        createUpdateFunc,
    } = useDealContext()
    const openModal = useModalsStore((state) => state.openModal)
    const formattedQuote = dealState.formatted_quote
    const [paymentState, setPaymentState] = useState({
        desired_payment: dealState.desired_payment || formattedQuote.monthly_payment,
        is_drive_off_cap_reduction: dealState.is_drive_off_cap_reduction,
        drive_off: dealState.drive_off,
        _should_update: false
    })
    const [msds, setMsds] = useState(0)
    const [creditScore, setCreditScore] = useState('')

    const clearCostFields = () => {
        const fieldValues = {
            invoice_plus: '',
            invoice_minus: '',
            msrp_plus: '',
            msrp_minus: '',
            msrp_percentage: ''
        }
        setDealStateWithUpdate({...fieldValues})
    }

    const setPaymentStateObj = (field, value, newDealState, shouldUpdate) => {
        setPaymentState({
            ...paymentState,
            [field]: value,
        })
        setDealStateWithUpdate(newDealState, shouldUpdate)
    }

    const setPaymentValueWithDealStateUpdate = (newDealState) => {
        const formattedQuote = newDealState.formatted_quote
        setPaymentState({
            desired_payment: formattedQuote.monthly_payment,
            is_drive_off_cap_reduction: newDealState.is_drive_off_cap_reduction,
            drive_off: newDealState.drive_off
        })
    }

    useEffect(function setPaymentValueWithDealStateUpdateEffect(){
        const newDealState = updateDealResponse?.data?.data
        if (newDealState && !updateDealResponse.loading && !updateDealResponse.error) {
            setPaymentValueWithDealStateUpdate(newDealState)
        }
    }, [updateDealResponse])

    if (!dealState) return null;

    const isLoading = updateDealResponse?.loading && dealState._no_update !== true
    const isPurchase = dealState.is_purchase
    const isDisabled = !dealState.msrp || !dealState.cost

    const isCashPayment = dealState.is_purchase && dealState.is_one_pay
    const isOnePayLease = !dealState.is_purchase && dealState.is_one_pay

    const cashName = paymentState.is_drive_off_cap_reduction ? 'Cap Reduction:' : 'Total Drive Off:'
    const toggleTooltipName = paymentState.is_drive_off_cap_reduction ? 'Total Drive Off' : 'Cap Reduction'
    const isUsed = !dealState.car_detail.is_new

    return (
        <React.Fragment>
            <Box className={classnames("dealPagePayment-column panel-pricing", {
                mobile: isTabletOrMobile
            })}>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className={'header'}
                >
                    <Stack
                        direction={'row'}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <span>Vehicle Pricing</span>
                        <LocalOfferOutlinedIcon sx={{color: dealColorLight()}}/>
                    </Stack>

                </Typography>
                <Divider className={'divider'}/>
                {
                    !isUsed &&
                    <React.Fragment>
                        <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                MSRP:
                            </span>
                            <CustomCurrencyInput
                                className={classnames('payment-row_value', {
                                    loading: isLoading
                                })}
                                placeholder={'0'}
                                value={dealState.msrp}
                                onChange={(value) => setDealStateWithUpdate({msrp: value})}
                            />
                        </div>
                        <div
                            className={'payment-row'}
                        >
                    <span
                        className={'payment-row_name'}
                    >
                        Invoice:
                    </span>
                            <CustomCurrencyInput
                                className={classnames('payment-row_value', {
                                    loading: isLoading
                                })}
                                placeholder={'0'}
                                value={dealState.invoice}
                                onChange={(value) => setDealStateWithUpdate({invoice: value})}
                            />
                        </div>
                    </React.Fragment>
                }
                {
                    isUsed &&
                    <React.Fragment>
                        <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                Book Value:
                            </span>
                            <CustomCurrencyInput
                                className={classnames('payment-row_value', {
                                    loading: isLoading
                                })}
                                placeholder={'0'}
                                value={dealState.msrp}
                                onChange={(value) => setDealStateWithUpdate({msrp: value})}
                            />
                        </div>
                        <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                Certified Pre-Owned: <strong>{dealState.is_certified_preowned ? 'Yes' : 'No'}</strong>
                            </span>

                            <Switch
                                size={'small'}
                                checked={dealState.is_certified_preowned}
                                onChange={(value) => setDealStateWithUpdate({is_certified_preowned: !dealState.is_certified_preowned})}
                            />
                        </div>
                        <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                Current Mileage:
                            </span>
                            <CustomCurrencyInput
                                className={classnames('payment-row_value', {
                                    loading: isLoading
                                })}
                                prefix="$"
                                value={dealState.current_mileage}
                                onChange={(value) => setDealStateWithUpdate({current_mileage: value})}
                                disabled={isLoading}
                                InputProps={{}}
                            />
                        </div>
                    </React.Fragment>
                }
                <div
                    className={'payment-row'}
                >
                            <span
                                className={'payment-row_name'}
                            >
                                Cost: <CostCalculator state={dealState} setState={setDealStateWithUpdate}
                                                      isLoading={isLoading}/>
                            </span>
                    <CustomCurrencyInput
                        className={classnames('payment-row_value', {
                            loading: isLoading
                        })}
                        placeholder={'0'}
                        value={dealState.cost}
                        onChange={(value) => setDealStateWithUpdate({cost: value})}
                        onKeyDown={clearCostFields}
                    />
                </div>

                <div
                    className={'payment-row'}
                >
                    <span
                        className={'payment-row_name'}
                    >
                        Profit:
                    </span>
                    <CustomCurrencyInput
                        className={classnames('payment-row_value', {
                            loading: isLoading
                        })}
                        prefix="$"
                        value={dealState.profit}
                        onChange={(value) => setDealStateWithUpdate({profit: value})}
                    />
                </div>
                <Divider />
                <div
                    className={'payment-row'}
                >
                    <span
                        className={'payment-row_name'}
                    >
                        Selling Price:
                    </span>
                    <CustomCurrencyInput
                        className={classnames('payment-row_value disabled', {
                            loading: isLoading
                        })}
                        value={dealState.selling_price || (Number(dealState.cost) + Number(dealState.profit))}
                        disabled={true}
                    />
                </div>
                <Tooltip title="Click or Press Enter to Calculate" arrow placement={'bottom'}>
                    <Button
                        className={classnames('dealPage-button', {
                            isDisabled: isDisabled
                        })}
                        style={{background: dealColorLight()}}
                        onClick={createUpdateFunc}
                        disabled={isDisabled}
                    >
                        {
                            isLoading ? 'Calculating...' : 'Calculate'
                        }
                    </Button>
                </Tooltip>
            </Box>

            <Box className={classnames("dealPagePayment-column panel-structure", {
                mobile: isTabletOrMobile
            })}>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className={'header'}
                >
                    Structure
                </Typography>
                <Divider className={'divider'}/>
                {
                    isDealPage && !isCashPayment &&
                    <React.Fragment>
                        <div
                            className={'payment-row'}
                        >
                            <span
                                className={'payment-row_name'}
                            >
                                {isPurchase ? 'Custom Down Payment' : cashName}
                                {
                                    !isPurchase &&
                                    <Tooltip title={`Use cash as ${toggleTooltipName}`} arrow placement={'top'}>
                                        <Switch
                                            size={'small'}
                                            sx={{ marginLeft: '5px'}}
                                            disabled={isLoading}
                                            checked={paymentState.is_drive_off_cap_reduction}
                                            onChange={
                                                (value) => {
                                                    const updateObj = {
                                                        is_drive_off_cap_reduction: !paymentState.is_drive_off_cap_reduction,
                                                        desired_payment: null
                                                    }
                                                    setPaymentStateObj(
                                                        'is_drive_off_cap_reduction',
                                                        !paymentState.is_drive_off_cap_reduction,
                                                        updateObj,
                                                        true
                                                    )
                                                }

                                            }
                                        />
                                    </Tooltip>
                                }
                            </span>
                            <CustomCurrencyInput
                                className={classnames('payment-row_value', {
                                    loading: isLoading
                                })}
                                allowNull={true}
                                prefix="$"
                                value={paymentState.drive_off}
                                onChange={(value, sourceInfo) => {
                                    if (sourceInfo.source === 'event') {
                                        let updateObj = {drive_off: value, desired_payment: null}
                                        if (value === null) {
                                            updateObj = {...updateObj, is_drive_off_cap_reduction: false}
                                        }
                                        setPaymentStateObj(
                                            'drive_off',
                                            value,
                                            updateObj,
                                            false
                                        )
                                    }
                                }}
                            />
                        </div>
                    </React.Fragment>
                }
                <div className={'payment-row'}>
                    <span className={'payment-row_name'}>One Pay</span>
                    <Switch
                        size={'small'}
                        checked={dealState.is_one_pay}
                        onChange={() => setDealStateWithUpdate({is_one_pay: !dealState.is_one_pay})}
                    />
                </div>
                <div className={'payment-row'}>
                    <span className={'payment-row_name'}>MSD's</span>
                    <Select
                        className={'structure-select'}
                        value={msds}
                        onChange={(e) => setMsds(e.target.value)}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    bgcolor: '#161c2a',
                                    color: '#e0e0e0',
                                    border: '1px solid #252d3d'
                                }
                            }
                        }}
                    >
                        {[...Array(11)].map((_, i) => (
                            <MenuItem key={i} value={i} sx={{ color: '#e0e0e0' }}>{i}</MenuItem>
                        ))}
                    </Select>
                </div>
                {
                    dealState.id &&
                    <React.Fragment>
                        {
                            !isCashPayment &&
                            <div
                                className={'payment-row'}
                            >
                                <span
                                    className={'payment-row_name'}
                                >
                                    Term:
                                </span>
                                <CustomSelect
                                    className={classnames('CustomInput payment-row_value select', {
                                        loading: isLoading
                                    })}
                                    value={dealState.term}
                                    onChange={(event, newValue) => setDealStateWithUpdate({term: newValue})}
                                    handleHomeEndKeys
                                    options={termOptions}
                                    getOptionLabel={(option) => String(option)}
                                    freeSolo
                                    autoSelect
                                    forcePopupIcon
                                />
                            </div>
                        }
                        <div
                            className={'payment-row'}
                        >
                            {
                                !isPurchase &&
                                <>
                                    <span
                                        className={'payment-row_name'}
                                    >
                                        Mileage:
                                    </span>
                                    <CustomSelect
                                        onChange={(event, newValue) => setDealStateWithUpdate({mileage: newValue})}
                                        className={classnames('CustomInput payment-row_value select', {
                                            loading: isLoading
                                        })}
                                        options={mileageOptions}
                                        value={dealState.mileage}
                                        getOptionLabel={(option) => String(option)}
                                        handleHomeEndKeys
                                        freeSolo
                                        autoSelect
                                        forcePopupIcon
                                    />
                                </>
                            }
                        </div>
                    </React.Fragment>
                }
            </Box>

            <Box className={classnames("dealPagePayment-column panel-lender", {
                mobile: isTabletOrMobile
            })}>
                {
                    dealState.id &&
                    <React.Fragment>
                        <Typography
                            variant="h6"
                            component="div"
                            className={'header'}
                        >
                            <div className={'lender-details_container'}>
                                <span>Program Details</span>
                                <span className={'action-icon'}>
                                    <Tooltip title={'All Quotes'} arrow placement={'top'}>
                                        <RequestQuoteOutlinedIcon
                                            sx={{color: dealColorLight()}}
                                            id={'someId'}
                                            className={'action-icon'}
                                            onClick={() => {
                                              openModal({
                                                  element: DeskingModal,
                                                  id: "DeskingModal",
                                                  props: {
                                                      onSave: (updateData) => {
                                                          setDealStateWithUpdate(updateData, false)
                                                          setPaymentValueWithDealStateUpdate(updateData)
                                                      },
                                                      ...dealState,
                                                      dealState: dealState,
                                                      id: dealState.id,
                                                      deal_id: dealState.id,
                                                      selectedLender: dealState.formatted_quote.lender_name,
                                                      selectedTerm: dealState.term,
                                                      desired_payment: null,
                                                  }
                                              })
                                            }}
                                        />
                                    </Tooltip>
                                </span>
                            </div>
                        </Typography>
                        <Divider className={'divider'}/>
                        <Stack
                            className={'lender-name'}
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                        >
                            {formattedQuote.lender_name}
                            <Tooltip title={formattedQuote.program_description} arrow placement={'top'}>
                                <InfoOutlinedIcon
                                    sx={{
                                        color: dealColorLight,
                                        fontSize: '19px',
                                        marginLeft: '5px'
                                    }}
                                />
                            </Tooltip>
                        </Stack>
                        <div className={'payment-row'}>
                            <span className={'payment-row_name'}>Applicant Credit Score</span>
                            <input
                                type="text"
                                className={'lender-input'}
                                placeholder={'780'}
                                value={creditScore}
                                onChange={(e) => setCreditScore(e.target.value)}
                            />
                        </div>
                        {
                            !isPurchase &&
                            <>
                                <div className={'payment-row'}>
                                    <span
                                        className={'payment-row_name'}
                                    >
                                        Money Factor:
                                    </span>
                                    <span className={'payment-row_display'}>
                                        {formattedQuote.money_factor}
                                    </span>
                                </div>
                                <div className={'payment-row'}>
                                    <span
                                        className={'payment-row_name'}
                                    >
                                        Money Factor Override:
                                    </span>
                                    <CustomCurrencyInput
                                        className={classnames('payment-row_value', {
                                            loading: isLoading
                                        })}
                                        prefix=""
                                        value={dealState.money_factor_override}
                                        allowBlank={true}
                                        thousandSeparator={false}
                                        InputProps={{}}
                                        onChange={(value) =>  setDealStateWithUpdate({money_factor_override: value})}
                                    />
                                </div>
                                <div className={'payment-row residual-row'}>
                                    <span
                                        className={'payment-row_name'}
                                    >
                                        Residual:
                                    </span>
                                    <div className="residual-compact">
                                        <CustomCurrencyInput
                                            className={classnames('payment-row_value residual-base', {
                                                loading: isLoading
                                            })}
                                            value={formattedQuote.residual}
                                            disabled={true}
                                            thousandSeparator={false}
                                            InputProps={{}}
                                            prefix=""
                                        />
                                        <span className="residual-op">+</span>
                                        <CustomCurrencyInput
                                            className={classnames('payment-row_value residual-override', {
                                                loading: isLoading
                                            })}
                                            thousandSeparator={false}
                                            InputProps={{}}
                                            prefix=""
                                            value={dealState.residual_override}
                                            allowBlank={true}
                                            onChange={(value) => setDealStateWithUpdate({residual_override: value})}
                                        />
                                        <span className="residual-op">=</span>
                                        <span className="residual-total">
                                            {Number(formattedQuote.residual || 0) + Number(dealState.residual_override || 0)}%
                                        </span>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            isPurchase &&
                            <React.Fragment>
                                <div className={'payment-row'}>
                                        <span
                                            className={'payment-row_name'}
                                        >
                                            APR:
                                        </span>
                                    <CustomCurrencyInput
                                        className={classnames('payment-row_value disabled', {
                                            loading: isLoading
                                        })}
                                        InputProps={
                                            {
                                                endAdornment: (
                                                    <InputAdornment
                                                        sx={{ fontSize: '10px' }}
                                                        position="start">%
                                                    </InputAdornment>
                                                ),
                                            }
                                        }
                                        value={`${formattedQuote.apr}`}
                                        disabled={true}
                                    />
                                </div>
                                <div className={'payment-row'}>
                                <span
                                    className={'payment-row_name'}
                                >
                                    APR Override:
                                </span>
                                    <CustomCurrencyInput
                                        className={classnames('payment-row_value', {
                                            loading: isLoading
                                        })}
                                        thousandSeparator={false}
                                        InputProps={
                                            {
                                                endAdornment: (
                                                    <InputAdornment
                                                        sx={{ fontSize: '10px' }}
                                                        position="start">%
                                                    </InputAdornment>
                                                ),
                                            }
                                        }
                                        prefix=""
                                        value={dealState.interest_rate_override}
                                        allowBlank={true}
                                        onChange={(value) =>  setDealStateWithUpdate({interest_rate_override: value})}
                                    />
                                </div>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </Box>

            <Box className={classnames("dealPagePayment-column panel-payment", {
                mobile: isTabletOrMobile
            })}>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className={'header'}
                >
                    Payment
                </Typography>
                <Divider className={'divider'}/>
                {
                    dealState.id &&
                    <React.Fragment>
                        {
                            !isPurchase &&
                            <div className={'payment-row'}>
                                <span className={'payment-row_name'}>Amount Due at Signing:</span>
                                <span className={classnames('payment-row_display', 'blue')}>
                                    $ <NumericFormat
                                        value={formattedQuote.amount_due_at_signing}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={''}
                                    />
                                </span>
                            </div>
                        }
                        <div className={'payment-row'}>
                            <span className={'payment-row_name'}>
                                { isCashPayment ? '' : "Base "}Payment:
                            </span>
                            {
                                isOnePayLease &&
                                <span className={'payment-row_display'}>
                                    N/A
                                </span>
                            }
                            {
                                !isOnePayLease &&
                                <span className={'payment-row_display'}>
                                    $ <NumericFormat
                                        value={isCashPayment ? formattedQuote.monthly_payment : formattedQuote.base_payment}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={''}
                                    />
                                </span>
                            }
                        </div>
                        <div className={'payment-row'}>
                            <span className={'payment-row_name'}>Tax Rate:</span>
                            <span className={'payment-row_display'}>
                                <NumericFormat
                                    value={formattedQuote.tax_rate}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={''}
                                /> %
                            </span>
                        </div>
                        {
                            !isCashPayment &&
                            <div className={'payment-row'}>
                                <span className={'payment-row_name'}>Monthly Payment:</span>
                                <CustomCurrencyInput
                                    className={classnames('payment-row_value monthly-payment-input', {
                                        loading: isLoading,
                                        disabled: isPurchase,
                                    })}
                                    prefix=""
                                    value={paymentState.desired_payment}
                                    onChange={(value, sourceInfo) => {
                                        if (sourceInfo.source === 'event') {
                                            const updateObj = {
                                                desired_payment: value,
                                                drive_off: null,
                                            }

                                            setPaymentStateObj(
                                                'desired_payment',
                                                value,
                                                updateObj,
                                                false
                                            )
                                        }
                                    }}
                                    disabled={isPurchase}
                                    allowNull={true}
                                    InputProps={{}}
                                />
                            </div>
                        }
                    </React.Fragment>
                }
            </Box>
        </React.Fragment>
    )
}
